import { Link } from 'react-router-dom';
import { ArrowRight, Gift } from 'lucide-react';
import { SIGNUP_BONUS_AMOUNT } from '../../lib/types';

export default function CTASection() {
  return (
    <section className="py-20 sm:py-28 bg-slate-900 relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            'radial-gradient(circle at 1px 1px, rgb(255 255 255 / 0.03) 1px, transparent 0)',
          backgroundSize: '40px 40px',
        }}
      />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-tight">
          Generate Your First NCERT Paper Free
        </h2>
        <p className="text-lg text-slate-400 mt-4 max-w-xl mx-auto">
          Claim &#8377;{SIGNUP_BONUS_AMOUNT} in wallet credit and test Xed21
          with real Bloom's-aligned questions before you top up.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mt-10">
          <Link
            to="/auth"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-teal-700 text-white rounded-xl text-sm font-semibold hover:bg-teal-600 transition-all shadow-lg shadow-teal-700/25 hover:-translate-y-0.5"
          >
            <Gift className="w-4 h-4" />
            Claim &#8377;{SIGNUP_BONUS_AMOUNT} Free
            <ArrowRight className="w-4 h-4" />
          </Link>
          <a
            href="#pricing"
            className="inline-flex items-center gap-2 px-8 py-3.5 border border-slate-600 text-slate-300 rounded-xl text-sm font-semibold hover:bg-slate-800 hover:text-white transition-all"
          >
            View Pricing
          </a>
        </div>
      </div>
    </section>
  );
}
